import type { Media } from "./schemas";
import { responsiveImg } from "@/lib/responsive-image";

export function MediaLayer({
  media,
  alt,
  priority,
  sizes,
}: {
  media?: Media;
  alt: string;
  priority?: boolean;
  sizes?: string;
}) {
  if (!media?.url) return <div className="absolute inset-0 bg-muted" />;
  if (media.type === "video") {
    return (
      <video
        src={media.url}
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
      />
    );
  }
  const img = responsiveImg(media.url, sizes ?? "100vw");
  return (
    <img
      src={img.src}
      srcSet={img.srcSet}
      sizes={img.sizes}
      alt={alt}
      decoding="async"
      fetchPriority={priority ? "high" : "auto"}
      className={`absolute inset-0 w-full h-full object-cover${priority ? " ken-burns" : ""}`}
      draggable={false}
    />
  );
}
